package com.iregained.site.pages

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.LaunchedEffect
import com.iregained.site.components.sections.product.sections.ProductDemonstrationSection
import com.iregained.site.components.sections.promo.sections.PromoBookingSection
import com.iregained.site.components.sections.promo.sections.PromoFooterExitSection
import com.iregained.site.components.sections.promo.sections.PromoHeroSection
import com.iregained.site.components.sections.promo.sections.PromoValueSection
import com.iregained.site.components.sections.resources.sections.ResourcesBrochureDownloadSection
import com.iregained.site.components.widgets.BackToTopButton
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import kotlinx.browser.document
import kotlinx.browser.window
import org.w3c.dom.HTMLMetaElement

@Page("myhand-exclusive-q7v9x2")
@Composable
fun PromoPage() {

    val ctx = rememberPageContext()
    val token = ctx.route.queryParams["access"]

    DisposableEffect(Unit) {
        val meta = document.createElement("meta") as HTMLMetaElement
        meta.name = "robots"
        meta.content = "noindex, nofollow"
        document.head?.appendChild(meta)

        onDispose { document.head?.removeChild(meta) }
    }

    LaunchedEffect(token) {
        if (token != "vip26") {
            window.location.replace("/")
        }
    }

    if (token == "vip26") {
        // Wrap everything in a Box so the BackToTopButton can float on top of the Column
        Box(modifier = Modifier.fillMaxSize()) {

            // Main Page Content
            Column(modifier = Modifier.fillMaxSize()) {
                PromoHeroSection()
                PromoBookingSection()
                PromoValueSection()
                ProductDemonstrationSection()
                ResourcesBrochureDownloadSection()

                // Soft exit to the main site
                PromoFooterExitSection()
            }

            // Standard floating action button
            BackToTopButton()
        }
    }
}